export const createCustomDataObject = (statName, statValue, data, numericFields, position = 0) => ({
    id: `${statName}-${statValue}`,
    statName,
    statValue,
    data,
    numericFields,
    position,
})

export const DTVSectionType = {
    DLC: "DLC",
    PROFILES: "PROFILES",
}

/**
 * Returns a list of sections that are valid for the given feature arguments.
 * E.g. sections = [{ seciont: MyFaveSection, validFor: [DTVSectionType.PROFILES] }]
 *     and args = { isDLC: false } will return [MyFaveSection]
 *
 * @param  {Array} sections       [array of objects with keys 'section' and 'validFor']
 * @param  {Object} options       [feature arguments, { isDLC, isFutureFeature, ... }]
 * @return {Array}                [array of sections (value of 'section' key in objects valid for feature)]
 */
export const getDTVSectionsForFeature = (sections, { isDLC }) => {
    let type
    switch (true) {
        case isDLC:
            type = DTVSectionType.DLC
            break
        default:
            type = DTVSectionType.PROFILES
            break
    }

    return (
        sections
            // filter out sections that are undefined
            .filter(({ section }) => section)
            // filter by the feature args
            .filter(({ validFor }) => validFor.includes(type))
            // map from object to the section
            .map(({ section }) => section)
    )
}

/**
 * Adds extra dispatches for start/success/error cases when calling loadActionCreator.
 * @param  {Action} options.loadActionCreator [action creator function]
 * @param  {Number} options.profileId         [id of profile (the param passed to loadActionCreator)]
 * @param  {Object} options.handlers          [object of action-creators with keys `startHandler`, `successHandler`, `errorHandler`]
 * @param  {Array} options.extra              [array of dehydrate_extra attributes]
 */
export const attachActionHandlers =
    ({ loadActionCreator, profileId, handlers, extra = [] }) =>
    (dispatch) => {
        // to appease the profiles tests, if there are no handlers given
        // then just dispatch the loadActionCreator (no .then/.catch)
        if (!handlers || !Object.keys(handlers).length) {
            return dispatch(loadActionCreator(profileId, extra))
        }

        const { startHandler, successHandler, errorHandler, redirectHandler } = handlers
        if (startHandler) {
            dispatch(startHandler(profileId))
        }
        return dispatch(loadActionCreator(profileId, extra))
            .then((response) => {
                if (response.status_code === 205 && redirectHandler) {
                    return dispatch(redirectHandler(response))
                } else if (successHandler) {
                    return dispatch(successHandler(response))
                }
            })
            .catch((error) => {
                if (errorHandler) {
                    return dispatch(errorHandler(error))
                }
            })
    }
